import React, { useEffect } from 'react'
import { Button } from 'antd'
import { PlusOutlined } from '@ant-design/icons'

const Stream = () => {
  const actionButton = () => {
    return (
      <>
        <Button
          href='https://www.slerp.com/menu-order-management-system-book-a-demo/'
          target='_blank'
          data-testid='request-demo-btn'
          className='ant-btn flex content-center justify-center gap-1 text-l h-full px-4 !py-1 items-center bg-[#d092dd] border-[#d092dd] rounded-full uppercase'
        >
          <PlusOutlined />
          Request Demo
        </Button>
      </>
    )
  }

  useEffect(() => {
    const script = document.createElement('script')

    script.src =
      'https://cdn.tailwindcss.com?plugins=forms,typography,aspect-ratio,line-clamp,container-queries'
    script.async = true

    document.body.appendChild(script)

    return () => {
      document.body.removeChild(script)
    }
  }, [])

  return (
    <>
      <div className=''>
        <div className='container bg-white mx-auto'>
          <div className='flex justify-center'>
            <div className='w-full text-center'>
              <h1 className='mb-6 mt-12 text-xl font-bold text-[#d092dd] uppercase'>
                Order management system
              </h1>
              <div className='mb-6 text-4xl font-extrabold text-gray-800'>
                Slerp's Menu & Order
                <br />
                Management System
              </div>
              <div className='mb-6 text-lg text-gray-600'>
                Bring together your marketplace and Slerp orders, with an
                automated POS-integrated platform.
              </div>
            </div>
          </div>
        </div>

        <div className='bg-white'>
          <div className='container bg-white mx-auto flex justify-center'>
            {actionButton()}
          </div>
        </div>

        <div className=''>
          <div className='container bg-white mx-auto'>
            <div className='flex flex-wrap justify-between items-center'>
              <div className='w-full md:w-1/2 lg:w-6/12'>
                <div className='mb-12 text-center'>
                  <h2 className='text-3xl font-bold text-gray-800'>
                    Slerp, Uber Eats, Deliveroo & Just Eat – <br />
                    managed with ease
                  </h2>
                </div>
                <div className='grid grid-cols-2 gap-2'>
                  <div className=''>
                    <div className='rounded h-full bg-white border p-6 shadow-lg'>
                      <h5 className='text-xl font-semibold text-gray-800'>
                        Menu Push with one-click
                      </h5>
                      <p className='text-sm text-gray-600'>
                        Push your menu from your POS directly to Slerp and the
                        marketplace channels (Uber Eats, Deliveroo, Just Eat).
                      </p>
                    </div>
                  </div>
                  <div className=''>
                    <div className='rounded h-full bg-white border p-6 shadow-lg'>
                      <h5 className='text-xl font-semibold text-gray-800'>
                        No need for multiple tablets
                      </h5>
                      <p className='text-sm text-gray-600'>
                        Control every aspect of your orders without the need for
                        multiple tablets for every platform.
                      </p>
                    </div>
                  </div>
                  <div className=''>
                    <div className='rounded h-full bg-white border p-6 shadow-lg'>
                      <h5 className='text-xl font-semibold text-gray-800'>
                        All orders sent directly into your POS
                      </h5>
                      <p className='text-sm text-gray-600'>
                        Simplify your operations by consolidating all orders in
                        one place, directly to your POS system.
                      </p>
                    </div>
                  </div>
                  <div className=''>
                    <div className='rounded h-full bg-white border p-6 shadow-lg'>
                      <h5 className='text-xl font-semibold text-gray-800'>
                        Tailor your setup with ease
                      </h5>
                      <p className='text-sm text-gray-600'>
                        Manage menus and settings at every location and every
                        channel. Save hours every day.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className='w-full md:w-5/12'>
                <img
                  className='w-full rounded'
                  src='https://www.slerp.com/wp-content/uploads/2024/11/Restaurant-SEO-64.png'
                  alt='order management system mechanics'
                />
              </div>
            </div>
          </div>
        </div>

        <div className=''>
          <div className='container bg-white mx-auto'>
            <div className='flex flex-wrap justify-between items-center'>
              <div className='w-full md:w-1/2 lg:w-6/12'>
                <div className='mb-12 text-center'>
                  <h2 className='text-3xl font-bold text-gray-800'>
                    Manage all of your digital ordering channels
                  </h2>
                </div>
                <div className='grid grid-cols-2 gap-2'>
                  <div className=''>
                    <div className='rounded h-full bg-white border p-6 shadow-lg'>
                      <h5 className='text-xl font-semibold text-gray-800'>
                        Set pricing per channel, per location
                      </h5>
                      <p className='text-sm text-gray-600'>
                        Easily adjust pricing at every location per channel.
                        Perfect for multi-site concepts with regional price
                        differences.
                      </p>
                    </div>
                  </div>
                  <div className=''>
                    <div className='rounded h-full bg-white border p-6 shadow-lg'>
                      <h5 className='text-xl font-semibold text-gray-800'>
                        Automatically match your POS menu with existing
                        marketplace menus
                      </h5>
                      <p className='text-sm text-gray-600'>
                        For ultra-fast onboarding and syncing, join the dots
                        between your existing menus across systems.
                      </p>
                    </div>
                  </div>
                  <div className=''>
                    <div className='rounded h-full bg-white border p-6 shadow-lg'>
                      <h5 className='text-xl font-semibold text-gray-800'>
                        Customise menus per channel per location
                      </h5>
                      <p className='text-sm text-gray-600'>
                        Tailor your POS menu push across all channels and all
                        locations with a few clicks.
                      </p>
                    </div>
                  </div>
                  <div className=''>
                    <div className='rounded h-full bg-white border p-6 shadow-lg'>
                      <h5 className='text-xl font-semibold text-gray-800'>
                        Instantly markup pricing for Marketplaces
                      </h5>
                      <p className='text-sm text-gray-600'>
                        Got a different price for menu items on marketplaces
                        compared to your POS? No problem, mark it up with ease.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className='w-full md:w-5/12'>
                <img
                  className='w-full rounded-lg'
                  src='https://www.slerp.com/wp-content/uploads/2024/11/Restaurant-SEO-62.png'
                  alt='order management system on a tablet'
                />
              </div>
            </div>
          </div>
        </div>

        <div className='mt-16'>
          <div className='container bg-white mx-auto'>
            <div className='flex justify-center'>
              <div className='w-full text-center'>
                <div className='mb-6 text-4xl font-extrabold text-gray-800'>
                  FAQ
                </div>
                <div className='mb-6 text-lg text-gray-600'>
                  <details className='bg-gray-50 p-4 rounded-lg text-left'>
                    <summary className='font-semibold'>
                      How does Slerp Menu Manager Work?
                    </summary>
                    <div className='py-4'>
                      <p>
                        There are two main components for this Slerp product.
                      </p>
                      <br />
                      <p>
                        – Menu Management: This allows you to sync your POS menu
                        to your digital channels, including Slerp, Deliveroo,
                        Uber Eats and Just Eat. The menu ‘pushes’ (menu push)
                        from your POS catalogue to your online ordering channels
                        and ensures they are synced. Once pushed, you can then
                        edit aspects of the menu item and tailor settings for
                        each channel and location. For example, you may wish to
                        have a different price for your marketplace channels –
                        you can change this easily within the Slerp Menu & Order
                        Manager.
                        <br />– Order Ingestion: Orders placed on Slerp or any
                        of the third-party marketplaces, will automatically be
                        sent to your POS system. This removes the need for
                        multiple tablets within a venue, and also allows for
                        easier reconciliation as all orders will be within the
                        POS system.
                      </p>
                    </div>
                  </details>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Stream
